import {Link, useLocation, useNavigate} from "react-router-dom";

import React from "react";
import {logout} from "../../shared/AuthService";
const accountLinks = [
    { href: "/account-page", label: "Dashboard" },
    { href: "/account-orders", label: "My Orders" },
    { href: "/account-details", label: "Account Details" },
    { href: "/logout", label: "Logout" },
];
export default function DbSidebar() {
    const { pathname } = useLocation();

    const navigate = useNavigate();

    const handleLogout = (e) => {
        e.preventDefault(); // Link davranışını engelle
        logout(); // auth.js içindeki fonksiyonu çağır
        navigate("/"); // çıkış sonrası login'e yönlendir
    };
    return (
        <div
            className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account input-page"
            id="mbAccount"
        >
            <div className="canvas-wrapper">
                <div className="canvas-header">
                    <span className="title">SIDEBAR ACCOUNT</span>
                    <button
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div>
                <div className="canvas-body">
                    <div className="sidebar-account-wrap sidebar-mobile-append">
                        <ul className="my-account-nav">
                            {accountLinks.map((elm, i) => (
                                <li key={i}>
                                    {elm.href === "/logout" ? (
                                        <a
                                            href="/"
                                            onClick={handleLogout}
                                            className="text-sm link fw-medium my-account-nav-item"
                                        >
                                            {elm.label}
                                        </a>
                                    ) : (
                                        <Link
                                            to={elm.href}
                                            className={`text-sm link fw-medium my-account-nav-item  ${
                                                pathname == elm.href ? "active" : ""
                                            }`}
                                        >
                                            {elm.label}
                                        </Link>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
